import React, {Component} from 'react';
import {Select, Form, Button, DatePicker} from 'antd';
import moment from 'moment';
import locale from 'antd/lib/date-picker/locale/zh_CN';
import PropTypes from 'prop-types';
import {api, app} from "../app";

const FormItem = Form.Item;
const Option = Select.Option;

class bigDataFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            provinceList: [],
            teamList: [],
        };
    }

    async setData(data) {
        await app.setStateSync(this, data);
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.provinceData();
        this.props.change({type: 1, mark: '全国', province: '中国', title: '全国'});
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 省份数据
     * @returns {Promise<void>}
     */
    provinceData = async () => {
        let params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        let {flag, data, msg} = await app.post(api.ProvinceList, params);
        if (flag === 1) {
            await this.setData({provinceList: data});
        } else {
            app.alert(msg, "error");
        }
    }

    /**
     * 队伍数据
     * @returns {Promise<void>}
     */
    teamData = async (province) => {
        const {setFieldsValue} = this.props.form;
        if (province === '0') {
            await this.setData({teamList: []});
            setFieldsValue({team: undefined});
        } else {
            let params = {
                province,
                indexno: app.getData("indexno"),
                account: app.getData("account"),
            };
            let {flag, data, msg} = await app.post(api.ProvinceTeamList, params);
            if (flag === 1) {
                await this.setData({teamList: data});
                setFieldsValue({team: '0'});
            } else {
                app.alert(msg, "error");
            }
        }
    }

    /**
     * 提交
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, {province, team}) => {
            if (!err) {
                let result = {
                    type: 1,
                    mark: '全国',
                    province: '中国',
                    title: '全国'
                };
                if (province === '0') {
                    //全国
                } else if (province && team === '0') {
                    //全省
                    result.type = 2;
                    result.mark = province;
                    result.province = province;
                    result.title = province;
                } else if (team) {
                    //队伍
                    result.type = 3;
                    result.mark = team;
                    result.province = province;
                    result.title = (this.state.teamList.find(t => t.teamno === team) || {}).teamname;
                }
                this.props.change(result);
            }
        });
    }

    render() {
        let {provinceList, teamList} = this.state,
            {form} = this.props,
            {getFieldDecorator, getFieldValue} = form;
        return (
            <Form layout="inline" style={{textAlign: "right"}} onSubmit={this.handleSubmit}>
                <FormItem
                    label="队伍筛选"
                >
                    {getFieldDecorator('province', {
                        initialValue: '0'
                    })(
                        <Select style={{width: 120, margin: '0 10rpx'}} placeholder="选择省份"
                                onChange={this.teamData}>
                            <Option value="0">全国</Option>
                            {
                                provinceList.map((pro, i) => {
                                    return (
                                        <Option key={i} value={pro.area_name}>{pro.area_name}</Option>
                                    );
                                })
                            }
                        </Select>
                    )}
                </FormItem>
                <FormItem>
                    {getFieldDecorator('team')(
                        <Select style={{width: 200}} placeholder="选择队伍" disabled={getFieldValue('province') === '0'}>
                            <Option value="0">全省</Option>
                            {
                                teamList.map((team, i) => {
                                    return (
                                        <Option key={i} value={team.teamno}>{team.teamname}</Option>
                                    );
                                })
                            }
                        </Select>
                    )}
                </FormItem>
                <FormItem>
                    <Button
                        type="primary"
                        htmlType="submit"
                    >
                        搜索
                    </Button>
                </FormItem>
            </Form>
        );
    }
}

bigDataFilter.propTypes = {
    change: PropTypes.func.isRequired,
}

export default Form.create()(bigDataFilter);



// WEBPACK FOOTER //
// ./src/components/BigDataFilter2.jsx